import { Route } from '@angular/router';
import { AreaCategoriesComponent } from 'src/app/pages/datasets/area-categories/area-categories.component';
import { AreaCategoryEditComponent } from 'src/app/pages/datasets/area-category-edit/area-category-edit.component';
import { RoutingID } from '../../../../../sb-routing-enum';
import { SbIcons } from '@ngx-seatback/icons';

export const categories: Route = {
  path: 'areaCategories',
  title: 'nav.datasets.areas.categories',
  data: {
    icon: SbIcons.locationWorld,
    breadcrumb: 'nav.datasets.areas.categories',
    id: RoutingID.areaCategories,
  },
  children: [
    {
      path: '',
      component: AreaCategoriesComponent,
      data: {
        breadcrumb: '',
      },
    },
    {
      path: 'areaCategory-edit/:areaCategoryID',
      title: 'nav.datasets.areas.categories.edit',
      data: {
        icon: SbIcons.edit,
        breadcrumb: 'nav.datasets.areas.categories.edit',
        id: RoutingID.areaCategoryEdit,
      },
      children: [
        {
          path: '',
          component: AreaCategoryEditComponent,
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
    {
      path: 'areaCategory-create',
      title: 'nav.datasets.areas.categories.create',
      data: {
        icon: SbIcons.plus,
        breadcrumb: 'nav.datasets.areas.categories.create',
        id: RoutingID.areaCategoryCreate,
      },
      children: [
        {
          path: '',
          component: AreaCategoryEditComponent,
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
  ],
};
